export const STORAGE_TOKEN_KEY = 'auth_token';
